/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ItalicsIcon = /*#__PURE__*/ createSvgIcon(
  'ItalicsIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.5 16a.967.967 0 01-.71-.29.962.962 0 01-.29-.708.97.97 0 01.29-.71A.963.963 0 015.5 14h2.333l2.584-8H8a.967.967 0 01-.71-.29.962.962 0 01-.29-.708.97.97 0 01.29-.71A.963.963 0 018 4h6.5c.28 0 .517.096.71.29.193.192.29.428.29.708a.97.97 0 01-.29.71.963.963 0 01-.71.292h-2.083l-2.584 8H12c.28 0 .517.097.71.29.193.192.29.428.29.708a.97.97 0 01-.29.71A.963.963 0 0112 16H5.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ItalicsIcon;
